import React, { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import HttpService from '../../services/httpService';
import { setLoading, setSnackInfo } from "../../redux/actions/appAction";
import { Switch, FormControlLabel, IconButton, Button, Paper, Tooltip, TablePagination, Dialog, DialogTitle, DialogActions, TextField, MenuItem, Menu, Checkbox, ListItemText } from '@mui/material';
import { makeStyles } from '@material-ui/core/styles';
import { CSVLink } from 'react-csv';
import GetAppIcon from '@material-ui/icons/GetApp';
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import moment from 'moment';
import XLSX from 'xlsx';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import LinkOffIcon from '@material-ui/icons/LinkOff';
import Grid from "@material-ui/core/Grid";

const useStyles = makeStyles((theme) => ({
    switchRoot: {
        '& .MuiSwitch-switchBase': {
            color: '#F44336', // Red for off state
            '&.Mui-checked': {
                color: '#4CAF50', // Green for on state
                '& + .MuiSwitch-track': {
                    backgroundColor: '#4CAF50', // Green track for on state
                },
            },
        },
        '& .MuiSwitch-track': {
            backgroundColor: '#F44336', // Red track for off state
            borderRadius: '20px', // Rounded track
        },
        '& .MuiSwitch-thumb': {
            width: '18px', // Smaller thumb
            height: '18px',
        },
    },
    labelText: {
        fontWeight: 'bold',
        fontSize: '14px',
        transition: 'color 0.3s ease', // Smooth color transition
    },
    button: {
        textTransform: 'none',
        backgroundColor: 'white',
        color: '#333',
        borderRadius: '8px',
        border: '1px solid #ccc',
        cursor: 'pointer',
        transition: 'background-color 0.3s ease, color 0.3s ease',
        '&:hover': {
            backgroundColor: '#4CAF50',
            color: 'white',
        },
        '& .MuiButton-startIcon': {
            marginRight: 0,
        },
        '& .MuiButton-endIcon': {
            marginLeft: 0,
        },
    },
    paperContent: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        backgroundColor: '#f9f9f9', // Light background for paper
        padding: '20px',
        borderRadius: '8px',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)', // Soft shadow for paper
    },
    tableContainer: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
    },
    tableWrapper: {
        flex: 1, // Make table grow and take all remaining space
        overflowY: 'auto', // Enable vertical scroll when content overflows
        backgroundColor: '#fff', // White background for the table section
        borderRadius: '8px',
        boxShadow: '0 2px 6px rgba(0, 0, 0, 0.05)', // Soft shadow for the table
        marginBottom: '20px',
    },
    tableHeaderCell: {
        backgroundColor: '#0D47A1', // Dark Blue
        color: '#ffffff', // White text for contrast
        fontWeight: 'bold',
        padding: '10px',
        borderBottom: '1px solid #ccc',
    },
    actionsWrapper: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '20px',
    },
    tableWrapperWithPagination: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1, // Table grows to take the remaining space
    },
    paper: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
        marginBottom: '10px'
    },
    leadSearchButton: {
        backgroundColor: '#FDB913 !important',  // Bright Yellow for emphasis
        color: '#1C375D !important',            // Dark Blue text for contrast
        '&:hover': {
            backgroundColor: '#E6A411 !important', // Darker yellow on hover
        },
        padding: '5px 15px',
        borderRadius: '20px', // Curved edges
        width: '15%',
    },
    leadClearButton: {
        backgroundColor: '#FFF2EB !important',   // Light Beige
        color: '#1C375D !important',             // Decorpot Orange text
        '&:hover': {
            backgroundColor: '#E7BAD0 !important', // Light Pink on hover
        },
        padding: '5px 15px',
        borderRadius: '20px', // Curved edges
        width: '15%',
    },
}));

const CallLogsForLead = (props) => {
    const classes = useStyles();
    const { leadId } = useParams();
    const [callLogsData, setCallLogsData] = useState([]);
    const [callLogsCount, setCallLogsCount] = useState(0)
    const [showTagged, setShowTagged] = useState(true);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(100);
    const [csvData, setCsvData] = useState([]);
    const buttonRef = useRef(null);
    const [inputValues, setInputValues] = useState({});
    const [showSubmitMap, setShowSubmitMap] = useState({});
    const [untagBox, setUntagBox] = useState(false);
    const [rowId, setRowId] = useState("");
    const [storeDateFilter, setPivotDateFilters] = useState({ startDate: "", endDate: "" })
    const [selectedOption, setSelectedOption] = useState("Both");
    const [selectedCallStatus, setSelectedCallStatus] = useState("Both");
    const [maxWidth, setMaxWidth] = useState(150); // Initial width
    const [searchInput, setSearchInput] = useState("")
    const [selectedSearchType, setSelectedSearchType] = useState("");
    const searchTypes = ['Customer Name', 'Email ID', 'Lead No', 'Project No', 'Contact No', 'Unique Lead No'];
    const options = ["Both", "Outgoing", "Incoming"];
    const callStatus = ["Both", "Answered", "Missed"];

    const callTypeMap = {
        INBOUND: 'Incoming',
        OUTBOUND: 'Outgoing',
    };

    const convertToIST = (epochTime) => {
        // Create a Date object with the Epoch timestamp
        const date = new Date(epochTime);

        // Convert to IST by adding 5 hours and 30 minutes (since IST is UTC +5:30)
        date.setMinutes(date.getMinutes() + date.getTimezoneOffset() + 330);

        // Format the date into HH:MM AM/PM format (12-hour format)
        const hours = date.getHours() % 12 || 12;  // 12-hour format
        const minutes = date.getMinutes().toString().padStart(2, '0');
        const ampm = date.getHours() >= 12 ? 'PM' : 'AM';

        return `${hours}:${minutes} ${ampm}`;
    };

    const storePivotDate = (e) => {
        const { name, value } = e.target
        setPivotDateFilters({ ...storeDateFilter, [name]: value })
    }

    const headers = [
        { key: "leadId.lead_no", label: "Lead No" },
        { key: "user.name", label: "ERP User" },
        { key: "rolesData[0].name", label: "Role" },
        { key: "callerNumber", label: "Caller Number" },
        { key: "destinationNumber", label: "Destination Number" },
        { key: "formattedCallType", label: "Call Type" },
        // { key: "fromWaitingTime", label: "Waiting Duration" },
        { key: "conversationDuration", label: "Duration" },
        { key: "overallCallStatus", label: "Overall Call Status" },
        { key: "formattedRecordingURL", label: "Recordings" }
    ];

    useEffect(() => {
        retrieveCallLogs();
    }, []);

    const retrieveCallLogs = async (selectedOption, selectedCallStatus, page = 0, rowsPerPage = 100) => {
        props.setLoading(true);
        try {
            let params = {
                startDate: storeDateFilter.startDate,
                endDate: storeDateFilter.endDate,
                callType: selectedOption || "Both",
                overallCallStatus: selectedCallStatus || "Both",
                page: page,
                rowsPerPage: rowsPerPage
            };
            const response = await HttpService.getCDRForLead(leadId, params);
            setCallLogsData(response?.data.data);
            setCallLogsCount(response?.data.total)
            setCsvData(response?.data.data);
        } catch (error) {
            console.error("Error while fetching call logs", error);
        }
        props.setLoading(false);
    };

    const downloadExcel = () => {
        props.setLoading(true);
        try {
            setTimeout(() => {
                buttonRef.current.link.click();
            });
        } catch (err) {
            console.error(err.message);
        }
        props.setLoading(false);
    };

    const handleDownloadExcel = () => {
        if (!callLogsData || callLogsData.length === 0) {
            console.warn("No data available to download.");
            return;
        }

        const data = callLogsData.map((row, i) => ({
            "Sl. No.": i + 1,
            "Lead No": row?.leadId?.lead_no || "N/A",
            "ERP User": row?.user?.name || "N/A",
            "Role": row?.rolesData[0].name || "N/A",
            "Call Type": callTypeMap[row?.callType] || "N/A",
            "Caller Number": row?.callerNumber || "N/A",
            "Destination Number": row?.destinationNumber || "N/A",
            // "Waiting Duration (sec)": row?.fromWaitingTime || "NaN",
            "Call Duration (sec)": row?.conversationDuration || "NaN",
            "Overall Call Status": row?.overallCallStatus || "N/A",
            "Recordings": row.recordingURL ? row.recordingURL : "No Recording",
            "Date": row.createdAt ? moment(row.createdAt).format("DD-MM-YYYY") : "N/A",
        }));

        const ws = XLSX.utils.json_to_sheet(data);

        const callRecordingCol = "J";
        callLogsData.forEach((row, i) => {
            if (row.recordingURL) {
                const cellRef = `${callRecordingCol}${i + 2}`;
                ws[cellRef] = {
                    t: "s",
                    v: "Download",
                    l: { Target: row.recordingURL }, // Hyperlink target
                };
            }
        });

        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "CDR Logs");

        XLSX.writeFile(wb, `CDR_Logs_${moment().format("YYYYMMDD_HHmmss")}.xlsx`);
    };

    const handlePivotDateFilter = async () => {
        retrieveCallLogs(selectedOption, selectedCallStatus)
    }

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
        retrieveCallLogs(selectedOption, selectedCallStatus, newPage, rowsPerPage);
    };

    const handleChangeRowsPerPage = (event) => {
        const newRowsPerPage = parseInt(event.target.value, 10);
        setRowsPerPage(newRowsPerPage);
        setPage(0);
        retrieveCallLogs(selectedOption, selectedCallStatus, 0, newRowsPerPage);
    };

    const handleChange = async (event) => {
        const value = event.target.value;
        setSelectedOption(value);
        await retrieveCallLogs(event.target.value, selectedCallStatus);
    };

    const handleCallStatusChange = async (event) => {
        const value = event.target.value;
        setSelectedCallStatus(value);
        await retrieveCallLogs(selectedOption, event.target.value);
    };

    const handleConfirmationUntag = (id) => {
        setUntagBox(true)
        setRowId(id)
    }

    const handleUntag = async (rowId) => {
        setUntagBox(false)
        try {
            props.setLoading(true)
            let obj = {
                _id: rowId
            }
            const response = await HttpService.untagLead(obj)
            props.setLoading(false)
            retrieveCallLogs();
        } catch (error) {
            console.error(error)
        }
    }
    const formatDataForCSV = (data) => {
        return data.map((item) => {
            return {
                "Lead No": item?.leadId?.lead_no || "NA",
                "Caller Number": item?.callerNumber || "NA",
                "Destination Number": item?.destinationNumber || "NA",
                "Call Type": callTypeMap[item?.callType] || "NA",
                "Duration": item?.conversationDuration || "NA",
                "Recordings": item?.recordingURL || "No Records",
            };
        });
    };

    return (
        <div>
            <h2 style={{ textAlign: 'center', padding: '20px', fontWeight: 'bold', color: '#333' }}>Call Detail Recordings</h2>
            <Paper className={classes.paperContent}>
                <div>
                    <Grid container spacing={3} alignItems="center" justifyContent="space-between">
                        {/* Call Type Dropdown */}
                        <Grid item xs={12} sm={2}>
                            <TextField
                                select
                                label="Call Type"
                                variant="outlined"
                                size="small"
                                value={selectedOption}
                                onChange={handleChange}
                                fullWidth
                            >
                                {options.map((option) => (
                                    <MenuItem key={option} value={option}>
                                        {option}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </Grid>

                        {/* Call Status Dropdown */}
                        <Grid item xs={12} sm={2}>
                            <TextField
                                select
                                label="Overall Call Status"
                                variant="outlined"
                                size="small"
                                value={selectedCallStatus}
                                onChange={handleCallStatusChange}
                                fullWidth
                            >
                                {callStatus.map((option) => (
                                    <MenuItem key={option} value={option}>
                                        {option}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </Grid>

                        {/* Start Date */}
                        <Grid item xs={12} sm={2}>
                            <TextField
                                id="startDate"
                                name="startDate"
                                label="From Date"
                                type="date"
                                variant="outlined"
                                size="small"
                                value={storeDateFilter.startDate}
                                onChange={storePivotDate}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                fullWidth
                            />
                        </Grid>

                        {/* End Date */}
                        <Grid item xs={12} sm={2}>
                            <TextField
                                id="endDate"
                                name="endDate"
                                label="End Date"
                                type="date"
                                variant="outlined"
                                size="small"
                                value={storeDateFilter.endDate}
                                onChange={storePivotDate}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                fullWidth
                            />
                        </Grid>

                        {/* Submit Button */}
                        <Grid item xs={12} sm={2}>
                            <Button
                                variant="contained"
                                color="secondary"
                                onClick={handlePivotDateFilter}
                                fullWidth
                            >
                                Apply Date Filter
                            </Button>
                        </Grid>

                        {/* Download Button */}
                        <Grid item xs={12} sm={2}>
                            <Button
                                onClick={handleDownloadExcel}
                                color="primary"
                                variant="contained"
                                startIcon={<CloudDownloadIcon />}
                                fullWidth
                            >
                                Excel
                            </Button>
                        </Grid>

                        {/* Hidden CSVLink for export */}
                        <Grid item xs={12} sm={2}>
                            <CSVLink
                                headers={headers}
                                data={csvData}
                                ref={buttonRef}
                                filename="call_recordings.csv"
                                style={{ display: 'none' }} // Keeps it functional but hidden
                            />
                        </Grid>
                    </Grid>
                </div>

                <div className={classes.tableWrapperWithPagination}>
                    <div className="tableWrapper">
                        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                            <thead>
                                <tr>
                                    <th className={classes.tableHeaderCell}>Sl No.</th>
                                    <th className={classes.tableHeaderCell}>Lead No</th>
                                    <th className={classes.tableHeaderCell}>ERP User</th>
                                    <th className={classes.tableHeaderCell}>Role</th>
                                    <th className={classes.tableHeaderCell}>Call Type</th>
                                    <th className={classes.tableHeaderCell}>Caller Number</th>
                                    <th className={classes.tableHeaderCell}>Destination Number</th>
                                    {/* <th className={classes.tableHeaderCell}>Waiting Duration</th> */}
                                    <th className={classes.tableHeaderCell}>Call Duration</th>
                                    <th className={classes.tableHeaderCell}>Overall Call Status</th>
                                    <th className={classes.tableHeaderCell}>Recordings</th>
                                    <th className={classes.tableHeaderCell}>Date</th>
                                    <th className={classes.tableHeaderCell}>Time</th>
                                    <th className={classes.tableHeaderCell}>Untag Log</th>
                                </tr>
                            </thead>
                            <tbody>
                                {callLogsData?.map((log, index) => (
                                    <tr key={index}>
                                        <td style={{ padding: '10px', borderBottom: '1px solid #ccc' }}>{index + 1}</td>
                                        <td style={{ padding: '10px', borderBottom: '1px solid #ccc' }}>
                                            {log.leadId.lead_no ? log.leadId.lead_no : ""}
                                        </td>
                                        <td style={{ padding: '10px', borderBottom: '1px solid #ccc' }}>
                                            {log.user?.name ?? 'NA'}
                                        </td>
                                        <td style={{ padding: '10px', borderBottom: '1px solid #ccc' }}>
                                            {log.rolesData[0].name ?? 'NA'}
                                        </td>
                                        <td style={{ padding: '10px', borderBottom: '1px solid #ccc' }}>
                                            {callTypeMap[log.callType] ?? 'Type Unknown'}
                                        </td>
                                        <td style={{ padding: '10px', borderBottom: '1px solid #ccc' }}>
                                            {log.callerNumber ? log.callerNumber : 'Number Not Available'}
                                        </td>
                                        <td style={{ padding: '10px', borderBottom: '1px solid #ccc' }}>
                                            {log.destinationNumber ? log.destinationNumber : 'Number Not Available'}
                                        </td>
                                        {/* <td style={{ padding: '10px', borderBottom: '1px solid #ccc' }}>
                                            {log.fromWaitingTime
                                                ? `${log.fromWaitingTime} sec`
                                                : 'NaN'}
                                        </td> */}
                                        <td style={{ padding: '10px', borderBottom: '1px solid #ccc' }}>
                                            {log.conversationDuration
                                                ? `${log.conversationDuration} sec`
                                                : 'NaN'}
                                        </td>
                                        <td style={{ padding: '10px', borderBottom: '1px solid #ccc' }}>
                                            {log.overallCallStatus ?? 'Status Unknown'}
                                        </td>
                                        <td style={{ padding: '10px', borderBottom: '1px solid #ccc' }}>
                                            {log.recordingURL ? (
                                                <a
                                                    href={log.recordingURL}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    style={{ color: '#1976d2', textDecoration: 'none' }}
                                                >
                                                    <GetAppIcon />
                                                </a>
                                            ) : (
                                                "No Recordings"
                                            )}
                                        </td>
                                        <td style={{ padding: '10px', borderBottom: '1px solid #ccc' }}>{
                                            log.createdAt ? moment(log.createdAt).format("DD-MM-YYYY") : ''}
                                        </td>
                                        <td style={{ padding: '10px', borderBottom: '1px solid #ccc' }}>{
                                            log.startTime ? convertToIST(log.startTime) : ''}
                                        </td>
                                        <td>
                                            <Tooltip title="Untag the log">
                                                <IconButton color="primary" onClick={() => handleConfirmationUntag(log?._id)}>
                                                    <LinkOffIcon />
                                                </IconButton>
                                            </Tooltip>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    <TablePagination
                        rowsPerPageOptions={[100, 200, 400, { label: `${callLogsCount}`, value: callLogsCount }]}
                        colSpan={14}
                        count={callLogsCount}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        SelectProps={{
                            inputProps: { 'aria-label': 'rows per page' },
                            native: true,
                        }}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </div>
            </Paper>

            <Dialog
                open={untagBox}
                onClose={() => setUntagBox(false)}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle style={{ textAlign: "center", fontSize: 20 }}>
                    Are you sure?
                </DialogTitle>
                <DialogActions sx={{ justifyContent: "center", padding: 2 }}>
                    <Button variant="outlined" color="primary" onClick={() => handleUntag(rowId)}>
                        Submit
                    </Button>
                    <Button variant="outlined" color="secondary" onClick={() => setUntagBox(false)}>
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>

        </div>
    );
};

export default connect(null, { setLoading, setSnackInfo })(CallLogsForLead);